import { AnyAction } from 'redux';

import { State } from '../types';
import { actions } from '@wetransfer/transfer/store/action/ui';
import initialUiState from '@wetransfer/transfer/store/helper/ui';

export default function (
  state: State['ui'] = initialUiState,
  action: AnyAction
): State['ui'] {
  const { type } = action;

  switch (type) {
    case actions.GET_TIERS_PRICING:
      return {
        ...state,
        tiersPricing: action.payload,
      };

    case actions.GET_SEATS_PRICING:
      return {
        ...state,
        seatsPricing: action.seatsPricing,
      };

    case actions.RESET_TIERS_PRICING:
      return {
        ...state,
        tiersPricing: null,
      };

    case actions.RESET_SEATS_PRICING:
      return {
        ...state,
        seatsPricing: null,
      };

    case actions.SET_ACTIVE_PAYMENT_METHOD:
      return {
        ...state,
        payment: {
          ...state.payment,
          activeMethod: action.method,
        },
      };

    case actions.RESET_TIERS_ERRORS: {
      return {
        ...state,
        tiersPricing: Object.entries(state.tiersPricing || {}).reduce(
          (total, [key, value]) => {
            return {
              ...total,
              [key]: {
                year: { ...value['year'], error: null },
                month: { ...value['month'], error: null },
              },
            };
          },
          {}
        ),
      } as State['ui'];
    }

    case actions.SET_CREDIT_CARD_BRAND:
      return {
        ...state,
        payment: {
          ...state.payment,
          card: {
            ...state.payment.card,
            brand: action.brand,
          },
        },
      };

    case actions.SET_PAYMENT_METHOD_TO_COMPLETE:
      return {
        ...state,
        payment: {
          ...state.payment,
          [action.method]: {
            ...state.payment[action.method],
            complete: true,
          },
        },
      };

    case actions.RESET_PAYMENT_METHOD_TO_COMPLETE:
      return {
        ...state,
        payment: {
          ...state.payment,
          [action.method]: {
            ...state.payment[action.method],
            complete: false,
          },
        },
      };

    case actions.SET_UPLOADER_OPTIONS:
      return {
        ...state,
        uploader: {
          options: {
            ...state.uploader.options,
            ...action.options,
          },
        },
      };

    case actions.SET_SHOW_CONSENT_WALL_PREFERENCES: {
      return {
        ...state,
        showConsentWallPreferences: action.value,
      };
    }
  }

  return state;
}
